import Nabvar from '../../common/Nabvar'
import Sidebar from '../../common/Sidebar'
import Body from '../../ui/Body'

import React, { useEffect, useState } from "react";
import axios from "../../config/authaxios";
import Dropdown from "../../css/dropdown.module.scss";
import { Button, Card, Paper, Stack, Typography } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { useStyles } from "../../theme/theme";
import '../../css/table.scss'
import { useNavigate,useLocation } from "react-router-dom";

function HistoryDetail() {
    const navigate=useNavigate()
    const search=useLocation().search
    const orderId = new URLSearchParams(search).get("orderId");
    
  

  const [coupons, setCoupons] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(15);
  const [isType, setisType] = useState(" ");
  const [isMore, setIsMore] = useState(false);
  // const [load, setLoad] = useState(false);
  const [nodata, setNodata] = useState(false);
  const classes = useStyles();
  const [pageSize, setPageSize] = useState(25);
  const [payment,setPayment]=useState('freecash')
  const [process,setProcess]=useState('3')

  useEffect(() => {
    fetchCoupon();
  }, [payment,limit,process]);

  const fetchCoupon = () => {
    setPage(0);
    //console.log("page-->",page)
    setNodata(true);
    setIsMore(false);
    let query = {};

    if (page === 0 || page) {
      query.page=page;
      // temp += "page=" + page + "&";
    }

    if (limit) {
      query.limit=limit;
      // temp += "limit=" + limit + "&";
    }
    // temp += "type=" + isType + "&";
    query.payment_via=payment;
    query.process_status=process;

    //console.log("-->temp-->",temp)
    axios.get(`/admin/order/details/${orderId}`).then((res) => {
      //console.log(res.data.response);
      setNodata(true)
      let data = res.data.response;

      if (res.data.status) {
        setCoupons(data);
        if (data && data.length < limit) {
          setIsMore(true);
        }
        // if (data.length === 0) {
        //   setNodata(true);
        // } else {
        //   setNodata(false);
        // }
      setNodata(false)

        setPage(1);
      }
    });
  };

  return (
    <>
    <Nabvar/>
    <Sidebar/>
    <Body >

<Typography style={{ color: "#646777", fontSize: "1.7rem", width: "50%" }}>Payment History Details</Typography>
{/* <Stack spacing={2} direction='row'>
  <div className={Dropdown.dropdown}>
    {coupons.length > 0 && !isMore &&
      <Button variant="contained" color='info' sx={{ my: 2 }} className={Dropdown.dropbtn} onClick={Showmore}>More</Button>}
  </div>


  <div className={Dropdown.dropdown}>
    <Button variant="contained" color='info' sx={{ my: 2 }}>limit:{limit}</Button>
    <div className={Dropdown.dropdown_content}>
      <a className={limit === 25 ? "disabled" : "notDisabled"} onClick={() => { setLimit(25); setPage(0) }}>25</a>
      <a disabled={limit === 50 ? true : false} onClick={() => { setLimit(50); setPage(0) }}>50</a>
      <a disabled={limit === 100 ? true : false} onClick={() => { setLimit(100); setPage(0) }}>100</a>
      <a disabled={limit === 500 ? true : false} onClick={() => { setLimit(500); setPage(0) }}>500</a>
      <a disabled={limit === 1000 ? true : false} onClick={() => { setLimit(1000); setPage(0) }}>1000</a>
    </div>
  </div>

  <div className={Dropdown.dropdown}>
    <Button variant="contained" color='info' sx={{ my: 2 }}>Payment:{payment}</Button>
    <div className={Dropdown.dropdown_content}>
      <a  onClick={() => { setPayment('freecash'); setPage(0)}}>Freecash</a>
      <a  onClick={() => { setPayment("phonepe"); setPage(0) }}>Phonepe</a>
      
    </div>
  </div>

  <div className={Dropdown.dropdown}>
    <Button variant="contained" color='info' sx={{ my: 2 }}>Status:{process}</Button>
    <div className={Dropdown.dropdown_content}>
      <a  onClick={() => { setProcess('1');setPage(0)}}>1</a>
      <a  onClick={() => { setProcess("2");setPage(0) }}>2</a>
      <a  onClick={() => { setProcess("3");setPage(0) }}>3</a>
      
    </div>
  </div>
</Stack> */}
<Stack direction='column' justifyContent={"space-around"} sx={{marginBottom:"10px"}}>
    <h4>Product Name-<span style={{color:"rgb(220, 132, 73)"}}>{coupons?.p_name}</span></h4>
    <h4>Created at-<span style={{color:"rgb(220, 132, 73)"}}>{coupons?.created_at}</span></h4>
</Stack>
<div style={{width:"75vw",display:"flex",flexDirection:"center"}}>
<table  style={{borderCollapse: "collapse"}}>
  <thead style={{background:"#DC8449",color:"#fff"}}>
    <tr>
      <th>S. No.</th>
      <th>Card Number</th>
      <th>Card Pin</th>
      <th>Used</th>
 
    </tr>
  </thead>
  <tbody>
    {console.log("coupons",coupons.length)}
    {coupons?.cards?.length>0?coupons?.cards?.map((item, index) => {
      return (

        <tr key={index}>
          <td>{index+1}</td>
          <td>{item?.cardNumber}</td>
          <td>{item?.cardPin}</td>
          <td>{item?.is_used==true?"Yes":"No"}</td>
          {/* <td>{item?.email}</td> */}
          {/* <td>{item?.amount}</td>
          <td style={{textDecorationLine:"underline",cursor:"pointer"}} onClick={()=>navigate(`/history-detail?orderId=${item?.order_id}`)}>{item?.order_id}</td>
          <td>{item?.payment_via}</td>
          <td>{item?.status}</td>
          <td>{item?.process_status}</td>
          <td>{item?.is_free_cash}</td>
          <td>{item?.free_cash_amount}</td>
          <td>{item?.free_cash_txn_id}</td>
          <td>{item?.sku}</td>
          <td>{item?.used_at}</td>
          <td>{item?.paid_at}</td> */}
        </tr>
      );
    }):<div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>No Data Available</div>}
  </tbody>
</table>
</div>

{nodata && <section>Loading...</section>}

{/* {coupons.length > 0 && !isMore && <Button variant="contained" color='info' sx={{ my: 2 }} onClick={Showmore}>More</Button>} */}
</Body>
    </>
  )
}

export default HistoryDetail